import React, { useState, useEffect } from "react";
import Breadchrumb from "../components/Breadchrumb";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  useEffect(() => {
    document.title = "Contact JB Corporation | Linear Motion Products Supplier in Kathwada Ahmedabad Gujarat";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatusMessage(null);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_key: "8d85e490-6d11-40a9-a289-ec47e7ef0682",
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setStatusMessage("✅ Your message has been sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatusMessage("❌ Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatusMessage("❌ Network error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Breadchrumb pageName="Contact Us" />

      <section className="contact-page">
        <div className="container contact-container">
          {/* LEFT CONTACT INFO */}
          <div className="contact-page-info">
            <h2>
              Get in <span>Touch</span>
            </h2>
            <p>
              Have a question or need more details about our Linear Motion Products in Ahmedabad Gujarat? Reach out to us — our team
              is here to assist you with any inquiries for Rack & Pinion, Ball Screws, and LM Guides.
            </p>

            <div className="contact-details">
              <a href="tel:+919265581679" className="contact-card">
                <i className="fa-solid fa-phone"></i>
                <div>
                  <h4>Phone</h4>
                  <p>+91 92655 81679</p>
                  <p>+91 81608 54963</p>
                </div>
              </a>

              <a
                href="mailto:jbcorporation2023@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-card"
              >
                <i className="fa-solid fa-envelope"></i>
                <div>
                  <h4>Email</h4>
                  <p>jbcorporation2023@gmail.com</p>
                </div>
              </a>

              <a
                href="https://maps.app.goo.gl/qmCBM58s4wLLsih7A"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-card"
              >
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h4>Address</h4>
                  <p>
                    151 Ved industrial park 2, b/h shreenth estate, Kathwada
                    bhuvaladi road, Nr GIDC, Kathwada, Ahmedabad, Gujarat
                    382430
                  </p>
                </div>
              </a>
            </div>
          </div>

          {/* RIGHT CONTACT FORM */}
          <div className="contact-form">
            <h3>Send Us a Message</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="hidden"
                name="access_key"
                value="8d85e490-6d11-40a9-a289-ec47e7ef0682"
              />
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button
                type="submit"
                className="btn submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>

            {statusMessage && <p className="form-status">{statusMessage}</p>}
          </div>
        </div>

        {/* GOOGLE MAP */}
        <div className="map-container">
          <iframe
            title="JB Corporation Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.623757017053!2d72.70319797436807!3d23.037582815769603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e855f3c21b7b3%3A0xe9aac1b62bba235d!2sJB%20Corporation!5e0!3m2!1sen!2sin!4v1760532133370!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;
